import invariant from 'invariant';
import { OrderedMap } from 'immutable';
import {
  FETCH_NOTIFICATIONS_SUCCESS,
  SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS,
} from './actions';
import createNotification from './create';

export default function notifications(state = new OrderedMap({}), action = {}) {
  const { type, payload, notificationIds } = action;
  switch (type) {
    case SUBMIT_MARK_NOTIFICATIONS_READ_SUCCESS:
      return onMarkAsReadSuccess(notificationIds, state);
    case FETCH_NOTIFICATIONS_SUCCESS:
      return onFetchNotificationsSuccess(payload);
    default: return state;
  }
}

function onFetchNotificationsSuccess(payload) {
  invariant(Array.isArray(payload), 'payload must be an array');
  let newState = new OrderedMap({});// flush out the data once get new notification
  payload.forEach((item) => {
    const notification = createNotification(item);
    newState = newState.set(`${item.id}`, notification);
  });
  return newState
    .sortBy((n) => n.moment.valueOf())
    .reverse();
}

function onMarkAsReadSuccess(notificationIds, state) {
  let newState = state;
  notificationIds.forEach((id) => {
    newState = newState.delete(id);
  });
  return newState;
}



// WEBPACK FOOTER //
// ./data/Users/Notifications/reducer.js